<label class="k-mb-0" *ngIf="!location">
  <span class="pointer custom-lan {{ 'en' === selectedLang.value ? 'active' : '' }} " (click)="changeLang('en')">En<span>glish</span></span>
  |
  <span class="pointer custom-lan {{ 'si' === selectedLang.value ? 'active' : '' }}" (click)="changeLang('si')">සිං<span>හල</span></span>
</label>
<kendo-dropdownlist *ngIf="location === 'headerBar'" [formControl]="selectLanguage" [data]="laguageList" [valuePrimitive]="false">
  <ng-template kendoDropDownListValueTemplate let-dataItem
    ><img src="assets/images/transaltion-icon.jpg" /><span class="lang-info">{{ dataItem?.lang }} </span></ng-template
  >
  <ng-template kendoDropDownListItemTemplate let-dataItem>
    <span class="lang-info">{{ dataItem?.lang }} </span>
  </ng-template>

  <ng-template kendoDropDownListNoDataTemplate> </ng-template>
</kendo-dropdownlist>
<div class="product-lan" *ngIf="location === 'product-signup'">
  <span class="{{ 'en' === selectedLang.value ? 'active-n' : '' }} " (click)="changeLang('en')">En</span>
  <span class="{{ 'si' === selectedLang.value ? 'active-n' : '' }}" (click)="changeLang('si')">සිං</span>
</div>

<div class="login-lan" *ngIf="location === 'login-page'">
  <span class="{{ 'en' === selectedLang.value ? 'active-n' : '' }} " (click)="changeLang('en')">English</span>
  <span class="{{ 'bn' === selectedLang.value ? 'active-n' : '' }}" (click)="changeLang('bn')">বাংলা</span>
</div>

<div class="header-lan" *ngIf="location === 'header'">
  <span class="{{ 'en' === selectedLang.value ? 'active-header' : '' }} " (click)="changeLang('en')">English</span>
  <span class="{{ 'bn' === selectedLang.value ? 'active-header' : '' }}" (click)="changeLang('bn')">বাংলা</span>
</div>
